<div class="cxone-sidebar d-flex justify-content-end"
    [ngClass]="collapseSideBar ? '' : 'cxone-sidebar-collapsed'">
    <div>
        <svg [ngClass]="collapseSideBar ? '' : 'sidebar-btn-collapsed'" class="icon-24 sidebar-btn cursor-pointer"
            (click)="collapseSideBar ? collapseSideBar = false : collapseSideBar = true">
            <use href="../App_Themes/CXone/icons/sidebar-toggle.svg#sidebar-toggle">
            </use>
        </svg>
    </div>
</div>